/* tslint:disable */
/* eslint-disable */
/**
 * Melco Reporting APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportingMelcoMachineStatisticsModelsStatisticsListFilter
 */
export interface ReportingMelcoMachineStatisticsModelsStatisticsListFilter {
    /**
     * 
     * @type {Date}
     * @memberof ReportingMelcoMachineStatisticsModelsStatisticsListFilter
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ReportingMelcoMachineStatisticsModelsStatisticsListFilter
     */
    endDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof ReportingMelcoMachineStatisticsModelsStatisticsListFilter
     */
    groupList?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportingMelcoMachineStatisticsModelsStatisticsListFilter
     */
    designList?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReportingMelcoMachineStatisticsModelsStatisticsListFilter
     */
    isGrouped?: boolean;
}

export function ReportingMelcoMachineStatisticsModelsStatisticsListFilterFromJSON(json: any): ReportingMelcoMachineStatisticsModelsStatisticsListFilter {
    return ReportingMelcoMachineStatisticsModelsStatisticsListFilterFromJSONTyped(json, false);
}

export function ReportingMelcoMachineStatisticsModelsStatisticsListFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportingMelcoMachineStatisticsModelsStatisticsListFilter {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'startDate': !exists(json, 'startDate') ? undefined : (new Date(json['startDate'])),
        'endDate': !exists(json, 'endDate') ? undefined : (new Date(json['endDate'])),
        'groupList': !exists(json, 'groupList') ? undefined : json['groupList'],
        'designList': !exists(json, 'designList') ? undefined : json['designList'],
        'isGrouped': !exists(json, 'isGrouped') ? undefined : json['isGrouped'],
    };
}

export function ReportingMelcoMachineStatisticsModelsStatisticsListFilterToJSON(value?: ReportingMelcoMachineStatisticsModelsStatisticsListFilter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'startDate': value.startDate === undefined ? undefined : (value.startDate.toISOString()),
        'endDate': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
        'groupList': value.groupList,
        'designList': value.designList,
        'isGrouped': value.isGrouped,
    };
}


